import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { FC, ReactNode, useCallback, useState } from 'react';

import {
  accordionDetailsSx,
  accordionIconSx,
  accordionSummarySx,
  accordionSx,
  expandIconSx,
} from './styles/workcellFormStyles';
import { Icon as InstrumentIcon } from '../customIcons/instruments';

interface InstrumentAccordionProps {
  children: ReactNode;
  iconType: string;
  title: ReactNode;
}

export const InstrumentAccordion: FC<InstrumentAccordionProps> = ({
  children,
  iconType,
  title,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  return (
    <Accordion expanded={expanded} onChange={handleChange} sx={accordionSx}>
      <AccordionSummary sx={accordionSummarySx}>
        <ExpandMoreIcon sx={expandIconSx(expanded)} />
        <InstrumentIcon
          iconType={iconType}
          fontSize="large"
          sx={accordionIconSx}
        />
        <Typography variant="subtitle1" fontWeight={600} sx={{ width: '100%' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={accordionDetailsSx}>{children}</AccordionDetails>
    </Accordion>
  );
};
